import { memo } from "react";

import { Badge } from "@mantine/core";
import {
  TbArchive,
  TbCheck,
  TbCalendarExclamation,
  TbTrendingUp,
  TbTrendingDown,
  TbArrowRight,
  TbAlertTriangle
} from "react-icons/tb";

import { objectiveStatusColor } from "modules/strategy/utils/constants";

import { ObjectiveStatus } from "modules/strategy/types/entities";

type ObjectiveStatusBadgeProps = {
  isArchived: boolean;
  status: ObjectiveStatus;
};

const ObjectiveStatusBadge = (props: ObjectiveStatusBadgeProps) => {
  const { isArchived, status } = props;

  const label = isArchived ? "Archived" : status.replaceAll("_", " ");

  return (
    <Badge
      size="sm"
      variant="light"
      tt="capitalize"
      c={isArchived || status === "setup_required" ? "yellow.8" : undefined}
      leftSection={
        isArchived ? (
          <TbArchive size={14} />
        ) : status === "completed" ? (
          <TbCheck size={14} />
        ) : status === "past_due" ? (
          <TbCalendarExclamation size={14} />
        ) : status === "on_track" ? (
          <TbTrendingUp size={14} />
        ) : status === "off_track" ? (
          <TbTrendingDown size={14} />
        ) : status === "at_risk" || status === "setup_required" ? (
          <TbAlertTriangle size={14} />
        ) : status === "in_progress" ? (
          <TbArrowRight size={14} />
        ) : null
      }
      color={isArchived ? "yellow" : objectiveStatusColor[status]}
    >
      {label}
    </Badge>
  );
};

export default memo(ObjectiveStatusBadge);
